module.exports = __webpack_public_path__ + "static/media/logo_schwarz_orange.af76fd9b.png";